export class RegisterService {
  name = null;
  orderDate = new Date();
  quantity = 1;
  soldQuantity = 1;
  marketingVoucherCode = null;
  note = null;
  discount = null;
  percentDiscount = null;
  price = null;
  staffRevenues = [];
}
